{
  "clubId": "club-user",
  "initialCapacity": 15000,
  "maximumCapacity": 110000,
  "upgrades": [
    {
      "code": "STANDS_5000",
      "module": "STANDS",
      "capacityIncrease": 5000,
      "targetLevel": null,
      "cost": 3500000.0,
      "durationMatchdays": 1
    },
    {
      "code": "STANDS_20000",
      "module": "STANDS",
      "capacityIncrease": 20000,
      "targetLevel": null,
      "cost": 12000000.0,
      "durationMatchdays": 1
    },
    {
      "code": "STANDS_30000",
      "module": "STANDS",
      "capacityIncrease": 30000,
      "targetLevel": null,
      "cost": 17000000.0,
      "durationMatchdays": 1
    },
    {
      "code": "STANDS_45000",
      "module": "STANDS",
      "capacityIncrease": 45000,
      "targetLevel": null,
      "cost": 25000000.0,
      "durationMatchdays": 1
    },
    {
      "code": "STANDS_65000",
      "module": "STANDS",
      "capacityIncrease": 65000,
      "targetLevel": null,
      "cost": 35000000.0,
      "durationMatchdays": 1
    },
    {
      "code": "PARKING_L2",
      "module": "PARKING",
      "capacityIncrease": null,
      "targetLevel": 2,
      "cost": 2500000.0,
      "durationMatchdays": 1
    },
    {
      "code": "PARKING_L3",
      "module": "PARKING",
      "capacityIncrease": null,
      "targetLevel": 3,
      "cost": 2500000.0,
      "durationMatchdays": 1
    },
    {
      "code": "PARKING_L4",
      "module": "PARKING",
      "capacityIncrease": null,
      "targetLevel": 4,
      "cost": 2500000.0,
      "durationMatchdays": 1
    },
    {
      "code": "PARKING_L5",
      "module": "PARKING",
      "capacityIncrease": null,
      "targetLevel": 5,
      "cost": 2500000.0,
      "durationMatchdays": 1
    },
    {
      "code": "CAFETERIA_L2",
      "module": "CAFETERIA",
      "capacityIncrease": null,
      "targetLevel": 2,
      "cost": 2500000.0,
      "durationMatchdays": 1
    },
    {
      "code": "CAFETERIA_L3",
      "module": "CAFETERIA",
      "capacityIncrease": null,
      "targetLevel": 3,
      "cost": 2500000.0,
      "durationMatchdays": 1
    },
    {
      "code": "CAFETERIA_L4",
      "module": "CAFETERIA",
      "capacityIncrease": null,
      "targetLevel": 4,
      "cost": 2500000.0,
      "durationMatchdays": 1
    },
    {
      "code": "CAFETERIA_L5",
      "module": "CAFETERIA",
      "capacityIncrease": null,
      "targetLevel": 5,
      "cost": 2500000.0,
      "durationMatchdays": 1
    },
    {
      "code": "MERCHANDISING_L2",
      "module": "MERCHANDISING",
      "capacityIncrease": null,
      "targetLevel": 2,
      "cost": 2500000.0,
      "durationMatchdays": 1
    },
    {
      "code": "MERCHANDISING_L3",
      "module": "MERCHANDISING",
      "capacityIncrease": null,
      "targetLevel": 3,
      "cost": 2500000.0,
      "durationMatchdays": 1
    },
    {
      "code": "MERCHANDISING_L4",
      "module": "MERCHANDISING",
      "capacityIncrease": null,
      "targetLevel": 4,
      "cost": 2500000.0,
      "durationMatchdays": 1
    },
    {
      "code": "MERCHANDISING_L5",
      "module": "MERCHANDISING",
      "capacityIncrease": null,
      "targetLevel": 5,
      "cost": 2500000.0,
      "durationMatchdays": 1
    },
    {
      "code": "BATHROOMS_L2",
      "module": "BATHROOMS",
      "capacityIncrease": null,
      "targetLevel": 2,
      "cost": 2500000.0,
      "durationMatchdays": 1
    },
    {
      "code": "BATHROOMS_L3",
      "module": "BATHROOMS",
      "capacityIncrease": null,
      "targetLevel": 3,
      "cost": 2500000.0,
      "durationMatchdays": 1
    },
    {
      "code": "BATHROOMS_L4",
      "module": "BATHROOMS",
      "capacityIncrease": null,
      "targetLevel": 4,
      "cost": 2500000.0,
      "durationMatchdays": 1
    },
    {
      "code": "BATHROOMS_L5",
      "module": "BATHROOMS",
      "capacityIncrease": null,
      "targetLevel": 5,
      "cost": 2500000.0,
      "durationMatchdays": 1
    }
  ]
}
